<template>
  <CCard style="margin-top: 20px">
    <CCardHeader>
      <h5>HTML Game Form</h5>
    </CCardHeader>
    <CCardBody>
      <CCol sm="12">
        <p>Add Rage</p>
        <div class="form-group" v-for="(input, k) in this.addRage" :key="k">
          <CRow>
            <CCol sm="6">
              <!-- <label>Rage Fees</label> -->
              <input
                type="number"
                class="form-control"
                placeholder="Game Prize"
                v-model.number="addRage[k]"
              />
            </CCol>
            <CCol sm="2">
              <span>
                <CButton
                  color="danger"
                  @click="removeGamePrize(k)"
                  v-show="k || (!k && addRage.length > 1)"
                >
                  <i class="fa fa-times"></i
                ></CButton>
                &nbsp;&nbsp;&nbsp;
                <CButton
                  color="success"
                  @click="addGamePrize()"
                  v-show="k == addRage.length - 1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i
                ></CButton>
              </span>
            </CCol>
          </CRow>
        </div>
      </CCol>
      <CRow>
        <CCol sm="6">
          <label>Daily Limit</label>
          <CInput
            type="number"
            placeholder="Daily Limit"
            v-model.number="dailyLimit"
          />
        </CCol>
        <CCol sm="6">
          <label>Filter Limit</label>
          <CInput
            type="number"
            placeholder="Filter Limit"
            v-model.number="filterLimit"
          />
        </CCol>
        <CCol sm="6">
          <label>Base Point</label>
          <CInput
            type="number"
            placeholder="Base Point"
            v-model.number="basePoint"
          />
        </CCol>
        <CCol sm="6">
          <label>Fees</label>
          <CInput type="number" placeholder="fees" v-model.number="fees" />
        </CCol>
        <CCol sm="6">
          <label>Increment</label>
          <CInput
            type="number"
            placeholder="Increment"
            v-model.number="increment"
          />
        </CCol>
        <CCol sm="6">
          <label>Title</label>
          <CInput type="text" placeholder="title" v-model="title" />
        </CCol>
        <CCol sm="6">
          <label> start Time </label>
          <VueCtkDateTimePicker v-model="startTime" />
          <br />
        </CCol>
        <CCol sm="6">
          <label> End time </label>
          <VueCtkDateTimePicker v-model="endTime" />
          <br />
        </CCol>
        <CCol sm="6">
          <label>Extra pay Time</label>
          <VueCtkDateTimePicker v-model="extraPayTime" />
          <br />
        </CCol>
        <CCol sm="12">
          <CRow>
            <CCol sm="4">
              <span style="font-size: 14px; font-weight: bold">is Earn</span>
              <input
                v-model="isEarn"
                type="checkbox"
                value="isEarn"
                style="float: right; width: 113px; height: 22px"
              />
              <br />
              <br />
            </CCol>
            <CCol sm="4">
              <span style="font-size: 14px; font-weight: bold"
                >is FixedPayout</span
              >

              <input
                v-model="isFixedPayout"
                type="checkbox"
                value="isFixedPayout"
                style="float: right; width: 113px; height: 22px"
              />
              <br />
              <br />
            </CCol>
            <CCol sm="4">
              <span style="font-size: 14px; font-weight: bold">is Avail</span>

              <input
                v-model="isAvail"
                type="checkbox"
                value="isAvail"
                style="float: right; width: 113px; height: 22px"
              />
              <br />
              <br />
            </CCol>

            <CCol sm="4">
              <span style="font-size: 14px; font-weight: bold"
                >is ContestEnabled</span
              >
              <input
                v-model="isContestEnabled"
                type="checkbox"
                value="isContestEnabled"
                style="float: right; width: 113px; height: 22px"
              />
              <br />
              <br />
            </CCol>
            <CCol sm="4">
              <span style="font-size: 14px; font-weight: bold"
                >is settlement</span
              >
              <input
                v-model="issettlement"
                type="checkbox"
                value="issettlement"
                style="float: right; width: 113px; height: 22px"
              />
              <br />
              <br />
            </CCol>
            <CCol sm="4">
              <span style="font-size: 14px; font-weight: bold"
                >is FreeOpen</span
              >
              <input
                v-model="isFreeOpen"
                type="checkbox"
                value="isFreeOpen"
                style="float: right; width: 113px; height: 22px"
              />
              <br />
              <br />
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="6">
          <label>Game Point Multiplier</label>
          <CInput
            type="number"
            placeholder="Game Point Multiplier"
            v-model.number="gamePointMultiplier"
          />
        </CCol>
        <CCol sm="6">
          <label>initial OverallAverage</label>
          <CInput
            type="number"
            placeholder="initial OverallAverage"
            v-model.number="initialOverallAverage"
          />
        </CCol>
        <CCol sm="6">
          <label>initial PerdayAverage</label>
          <CInput
            type="number"
            placeholder="initial PerdayAverage"
            v-model.number="initialPerdayAverage"
          />
        </CCol>
        <CCol sm="6">
          <label>initial User OverallAvrg</label>
          <CInput
            type="number"
            placeholder="initial User OverallAvrg"
            v-model.number="initialUserOverallAvrg"
          />
        </CCol>
        <CCol sm="6">
          <label>initial User Per avrg</label>
          <CInput
            type="number"
            placeholder="initial User Per avrg"
            v-model.number="initialUserPerayAvrg"
          />
        </CCol>
        <CCol sm="6">
          <label>minimum Points</label>
          <CInput
            type="number"
            placeholder="minimum Points"
            v-model.number="minimumPoints"
          />
        </CCol>
        <CCol sm="6">
          <label>minimum Rage To Claim</label>
          <CInput
            type="number"
            placeholder="minimum Rage To Claim"
            v-model.number="minimumRageToClaim"
          />
        </CCol>
        <CCol sm="6">
          <label>payment Interval</label>
          <CInput
            type="number"
            placeholder="payment Interval"
            v-model.number="paymentInterval"
          />
        </CCol>
        <CCol sm="6">
          <label>platform</label>
          <CInput
            disabled
            type="text"
            placeholder="platform"
            v-model="platform"
          />
        </CCol>
        <CCol sm="6">
          <label>Icon</label>
          <CInput type="text" placeholder="icon URL" v-model="icon" />
        </CCol>
        <CCol sm="6">
          <label>tournamentId</label>
          <CInput
            type="number"
            placeholder="tournament Id"
            v-model.number="tournamentId"
          />
        </CCol>
        <CCol sm="6">
          <label>URL</label>
          <CInput type="text" placeholder="URL" v-model="url" />
        </CCol>
        <CCol sm="6">
          <label>wallet Address</label>
          <CInput
            type="text"
            placeholder="walletAddress"
            v-model="walletAddress"
          />
        </CCol>
        <CCol sm="12">
          <p>Add Rules</p>
          <div class="form-group" v-for="(input, k) in this.rules" :key="k">
            <CRow>
              <CCol sm="6">
                <!-- <label>Rage Fees</label> -->
                <input
                  type="text"
                  class="form-control"
                  placeholder="rule...."
                  v-model.number="rules[k]"
                />
              </CCol>
              <CCol sm="2">
                <span>
                  <CButton
                    color="danger"
                    @click="removeRules(k)"
                    v-show="k || (!k && rules.length > 1)"
                  >
                    <i class="fa fa-times"></i
                  ></CButton>
                  &nbsp;&nbsp;&nbsp;
                  <CButton
                    color="success"
                    @click="addRules()"
                    v-show="k == rules.length - 1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i
                  ></CButton>
                </span>
              </CCol>
            </CRow>
          </div>
        </CCol>
        <CCol sm="12">
          <p>Tournament Rules</p>
          <div
            class="form-group"
            v-for="(input, k) in this.tournamentRules"
            :key="k"
          >
            <CRow>
              <CCol sm="6">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Tournament rules...."
                  v-model.number="tournamentRules[k]"
                />
              </CCol>
              <CCol sm="2">
                <span>
                  <CButton
                    color="danger"
                    @click="removetournamentRules(k)"
                    v-show="k || (!k && tournamentRules.length > 1)"
                  >
                    <i class="fa fa-times"></i
                  ></CButton>
                  &nbsp;&nbsp;&nbsp;
                  <CButton
                    color="success"
                    @click="addtournamentRules()"
                    v-show="k == tournamentRules.length - 1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i
                  ></CButton>
                </span>
              </CCol>
            </CRow>
          </div>
        </CCol>
        <CCol sm="12">
          <h3>Tokens</h3>
          <div class="form-group" v-for="(input, k) in this.tokens" :key="k">
            <CRow>
              <CCol sm="6">
                <label> Token name</label>
                <CInput
                  type="text"
                  disabled
                  placeholder="platform"
                  v-model="input.name"
                />
              </CCol>
              <CCol sm="6">
                <label>Token Icon</label>
                <CInput
                  type="text"
                  placeholder="Token Icon"
                  v-model="input.icon"
                />
              </CCol>
              <CCol sm="6">
                <label>Token ContractAddress</label>
                <CInput
                  type="text"
                  placeholder="Token ContractAddress"
                  v-model="input.contractAddress"
                />
              </CCol>
              <CCol sm="6">
                <label>Token Fees</label>
                <CInput
                  type="number"
                  placeholder="Token Fees"
                  v-model.number="input.fee"
                />
              </CCol>
              <CCol sm="6">
                <label>token Tournament Fee</label>
                <CInput
                  type="number"
                  placeholder="token Tournament Fee"
                  v-model.number="input.tournamentFee"
                />
              </CCol>
              <CCol sm="6">
                <label>token Extra Tournament Fee</label>
                <CInput
                  type="number"
                  placeholder="token Extra Tournament Fee"
                  v-model.number="input.tournamentExtraFee"
                />
              </CCol>
              <CCol sm="6">
                <span style="font-size: 14px; font-weight: bold"
                  >is TokenContestEnabled
                </span>
                <input
                  v-model="input.isContestEnabled"
                  type="checkbox"
                  value="isTokenContestEnabled"
                  style="float: right; width: 113px; height: 22px"
                />
              </CCol>
              <CCol sm="6">
                <CButton
                  color="danger"
                  style="width: 50%"
                  @click="deleteToken(k)"
                  >Delete Token</CButton
                >
              </CCol>
            </CRow>
          </div>
        </CCol>
        <CCol sm="12">
          <h5>Add Token to the Game</h5>
        </CCol>
        <CCol sm="6">
          <CInput
            type="text"
            placeholder="Token Name in Capital"
            v-model="tokenName"
          />
        </CCol>
        <CCol sm="6">
          <CButton color="success" style="width: 50%" @click="addToken()"
            >add Token</CButton
          >
        </CCol>
        <CCol sm="12">
          <h3>Allow Free</h3>
        </CCol>
        <CCol>
          <div class="form-group" v-for="(input, k) in this.allowFree" :key="k">
            <CRow>
              <!-- <h3>Allow Free</h3> -->
              <CCol sm="5">
                <label> start Time </label>
                <VueCtkDateTimePicker v-model="input.startTime" />
                <br />
              </CCol>
              <CCol sm="5">
                <label> End time </label>
                <VueCtkDateTimePicker v-model="input.endTime" />
                <br />
              </CCol>
              <CCol sm="2">
                <br />
                <span>
                  <CButton
                    color="danger"
                    @click="removeAllowFree(k)"
                    v-show="k > 0"
                  >
                    <i class="fa fa-times"></i
                  ></CButton>
                  &nbsp;&nbsp;&nbsp;
                  <CButton color="success" @click="addAllowFree()">
                    <!-- v-show="k == this.allowFree?.length - 1" -->
                    <i class="fa fa-plus" aria-hidden="true"></i
                  ></CButton>
                </span>
              </CCol>
            </CRow>
          </div>
        </CCol>
        <CCol sm="12" style="text-align: center !important">
          <CButton color="success" style="width: 20%" @click="saveGame()"
            >Save</CButton
          >
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import moment from "moment";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  components: { VueCtkDateTimePicker },
  data() {
    return {
      dailyLimit: 0,
      filterLimit: 0,
      addRage: [0],
      fees: 0,
      increment: 0,
      extraPayTime: "",
      startTime: "",
      endTime: "",
      isEarn: false,
      isFixedPayout: false,
      isAvail: false,
      isContestEnabled: false,
      issettlement: false,
      gamePointMultiplier: 0,
      initialOverallAverage: 0,
      initialPerdayAverage: 0,
      initialUserOverallAvrg: 0,
      initialUserPerayAvrg: 0,
      minimumPoints: 0,
      minimumRageToClaim: 0,
      paymentInterval: 0,
      basePoint: 0,
      title: "",
      platform: "HTML",
      icon: "",
      isFreeOpen: false,
      rules: [""],
      tokenName: "",
      tournamentId: 0,
      url: "",
      walletAddress: "",
      tokens: {},
      tournamentRules: [""],
      allowFree: [
        {
          endTime: "",
          startTime: "",
        },
      ],
    };
  },
  methods: {
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    updateData() {
      this.dailyLimit = 0;
      this.filterLimit = 0;
      this.addRage = [0];
      this.fees = 0;
      this.increment = 0;
      this.extraPayTime = "";
      this.startTime = "";
      this.endTime = "";
      this.isEarn = false;
      this.isFixedPayout = false;
      this.isAvail = false;
      this.isContestEnabled = false;
      this.issettlement = false;
      this.gamePointMultiplier = 0;
      this.initialOverallAverage = 0;
      this.initialPerdayAverage = 0;
      this.initialUserOverallAvrg = 0;
      this.initialUserPerayAvrg = 0;
      this.minimumPoints = 0;
      this.minimumRageToClaim = 0;
      this.paymentInterval = 0;
      this.basePoint = 0;
      this.title = "";
      this.platform = "HTML";
      this.icon = "";
      this.isFreeOpen = false;
      this.rules = [""];
      this.tokenName = "";
      this.tournamentId = 0;
      this.url = "";
      this.walletAddress = "";
      this.tokens = {};
      this.tournamentRules = [];
      this.allowFree = [
        {
          endTime: "",
          startTime: "",
        },
      ];
    },
    saveGame() {
      const AllowFree = [];
      if (
        this.startTime == "" ||
        this.endTime == "" ||
        this.extraPayTime == ""
      ) {
        this.showMessage("Start Time Field are required ", "warning");
        return;
      }
      this.allowFree.forEach((e) => {
        if (e.startTime == "" || e.endTime == "") {
          this.showMessage("Allow Free Field are required ", "warning");
          return;
        }
        AllowFree.push({
          startTime: firebase.firestore.Timestamp.fromDate(
            new Date(e.startTime)
          ),
          endTime: firebase.firestore.Timestamp.fromDate(new Date(e.endTime)),
        });
      });
      if (
        this.dailyLimit == 0 ||
        this.filterLimit == 0 ||
        this.fees == 0 ||
        this.increment == 0 ||
        this.extraPayTime == "" ||
        this.startTime == "" ||
        this.endTime == "" ||
        this.gamePointMultiplier == 0 ||
        this.initialOverallAverage == 0 ||
        this.initialPerdayAverage == 0 ||
        this.initialUserOverallAvrg == 0 ||
        this.initialUserPerayAvrg == 0 ||
        this.minimumPoints == 0 ||
        this.minimumRageToClaim == 0 ||
        this.paymentInterval == 0 ||
        this.basePoint == 0 ||
        this.title == "" ||
        this.icon == "" ||
        this.tournamentId == 0 ||
        this.url == "" ||
        this.walletAddress == ""
      ) {
        this.showMessage("Some fields are Missing, try again", "warning");
        return;
      }

      db.collection("HTMLGames")
        .doc(this.title)
        .set({
          dailyLimit: this.dailyLimit,
          filterlimt: this.filterLimit,
          addRage: this.addRage,
          fee: this.fees,
          increment: this.increment,
          extrapayTime: firebase.firestore.Timestamp.fromDate(
            new Date(this.extraPayTime)
          ),
          startTime: firebase.firestore.Timestamp.fromDate(
            new Date(this.startTime)
          ),
          endTime: firebase.firestore.Timestamp.fromDate(
            new Date(this.endTime)
          ),
          earn: this.isEarn,
          fixedPayout: this.isFixedPayout,
          isAvail: this.isAvail,
          isContestEnabled: this.isContestEnabled,
          issettlement: this.issettlement,
          gamePointMultiplier: this.gamePointMultiplier,
          initialOverallAverage: this.initialOverallAverage,
          initialPerdayAverage: this.initialPerdayAverage,
          initialUserOverallAvrg: this.initialUserOverallAvrg,
          initialUserPerayAvrg: this.initialUserPerayAvrg,
          minimumPoints: this.minimumPoints,
          minimumRageToClaim: this.minimumRageToClaim,
          paymentInterval: this.paymentInterval,
          basePoint: this.basePoint,
          title: this.title,
          platform: this.platform,
          icon: this.icon,
          isFreeopen: this.isFreeOpen,
          rules: this.rules,
          tournamentId: this.tournamentId,
          url: this.url,
          walletAddress: this.walletAddress,
          tokens: this.tokens,
          allowFree: AllowFree,
          tournamentRules: this.tournamentRules,
        })
        .then(() => {
          this.showMessage("Data Saved Successfully", "success");
          this.updateData();
        });
    },
    addToken() {
      if (this.tokenName === "") return;
      this.tokens[this.tokenName] = {
        name: this.tokenName,
        icon: "",
        contractAddress: "",
        fee: 0,
        tournamentExtraFee: 0,
        tournamentFee: 0,
        isContestEnabled: false,
      };

      this.tokenName = "";
      this.$forceUpdate();
    },
    deleteToken(key) {
      this.tokens.delete(key);
      this.$forceUpdate();
    },
    addAllowFree() {
      this.allowFree.push({
        endTime: "",
        startTime: "",
      });
    },
    removeAllowFree(index) {
      this.allowFree.splice(index, 1);
    },
    addGamePrize() {
      this.addRage.push(0);
    },
    removeGamePrize(index) {
      this.addRage.splice(index, 1);
    },
    addRules() {
      this.rules.push("");
    },
    removeRules(index) {
      this.rules.splice(index, 1);
    },
    removetournamentRules(index) {
      this.tournamentRules.splice(index, 1);
    },
    addtournamentRules() {
      this.tournamentRules.push("");
    },
  },
};
</script>

<style>
</style>